(()=>{
  const calc=document.querySelector('[data-it-calc-root]');
  const multi=document.querySelector('.it-calc-multi');
  if(!calc||!multi||multi.dataset.itRouteFix==='1')return;
  multi.dataset.itRouteFix='1';

  const composition=()=>{
    const metals=new Set();
    let itemCount=0;
    multi.querySelectorAll('.it-calc-multi-row').forEach(row=>{
      const weight=Number(row.querySelector('[data-multi-weight]')?.value||0);
      if(!(weight>0))return;
      const metal=row.querySelector('[data-multi-metal]')?.value||calc.dataset.activeMetal||calc.dataset.calcMode||'gold';
      if(metal==='gold'||metal==='silver')metals.add(metal);
      itemCount++;
    });
    return{metal:metals.size===1?[...metals][0]:metals.size>1?'mixed':'',itemCount};
  };

  const sync=()=>{
    const state=composition();
    if(!state.itemCount||!state.metal)return;
    const destination=state.metal==='gold'?'/pages/sell-gold-london':'/pages/sell-precious-metals-london';
    multi.querySelectorAll('[data-it-multi-valuation]').forEach(link=>{
      const url=new URL(link.getAttribute('href')||destination+'#valuation',location.origin);
      url.pathname=destination;
      url.searchParams.set('calc_metal',state.metal);
      url.searchParams.set('calc_item_count',String(state.itemCount));
      if(!url.hash)url.hash='#valuation';
      link.href=url.pathname+url.search+url.hash;
    });
  };

  const later=()=>queueMicrotask(sync);
  multi.addEventListener('input',later);
  multi.addEventListener('change',later);
  multi.addEventListener('click',event=>{
    if(event.target.closest('[data-it-multi-valuation]'))sync();
    else if(event.target.closest('[data-it-add-row],[data-multi-remove]'))later();
  });
  document.addEventListener('imperial:precious-rates',later);
  later();
})();
